import { Paper } from '@material-ui/core'

import styled from 'styled-components'

const TablePaperContainer = styled(Paper)`
  height: inherit;
  padding: 10px;
  max-height: 65vh;
  overflow-y: scroll;
`

export default TablePaperContainer
